<template>
  <div v-if="dateValue"
       class="issue-date-table-cell">
    {{ formattedDate }}
  </div>
</template>

<script>
import moment from 'moment';

const DATE_FORMAT = 'DD MMM YYYY';

export default {
  name: 'DateTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dateValue() {
      return this.item[this.column.name];
    },
    formattedDate() {
      return moment(this.dateValue).format(DATE_FORMAT);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.issue-date-table-cell {
  font-family: $font-family-regular;
  font-size: rem(14);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--text-primary);
  width: rem(90);
  margin-left: rem(-5);
}

</style>
